import styled from '@emotion/styled'

import { palette, typography } from '../constants'
import Text from './Text'

type Color = 'black' | 'white'
type Kind = 'large' | 'normal' | 'section'

interface IProps {
  kind: Kind
  color?: Color
  inline?: boolean
}

const fontSizes = {
  large: typography.fontSize.title.large,
  normal: typography.fontSize.title.normal,
  section: typography.fontSize.title.section,
}

const lineHeights = {
  large: '40px',
  normal: '35px',
  section: '30px',
}

export default styled(Text.withComponent('h2'))<IProps>`
  ${({ inline }) => (inline ? 'display: inline;' : null)}

  color: ${({ color }) => (color ? palette[color] : palette.black)};
  font-size: ${({ kind }) => fontSizes[kind]};
  font-weight: ${typography.fontWeight.bold};
  line-height: ${({ kind }) => lineHeights[kind]};

  // HACK (alex): cross-bundle compatibility
  letter-spacing: unset;
  margin-bottom: unset;
`
